import { CustomTreatment } from "./custom-treatment.model";
import { ActionTypes } from "./custom-treatment.actions";
import { Action } from "@ngrx/store";

export interface State {
  customTreatments: CustomTreatment[];
  selectedCustomTreatment: CustomTreatment | null;
  searching: boolean;
  loading: boolean;
  showDetails: boolean;
}

export const initialState: State = {
  customTreatments: [],
  selectedCustomTreatment: null,
  searching: false,
  loading: false,
  showDetails: false,
};

export function reducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case ActionTypes.LIST:
      return Object.assign({}, state, { searching: true });

    case ActionTypes.LIST_COMPLETE:
      return Object.assign({}, state, {
        customTreatments: action.payload,
        searching: false,
      });

    case ActionTypes.LIST_FAIL:
      return Object.assign({}, state, { searching: false });

    case ActionTypes.LOAD:
      return Object.assign({}, state, { loading: true, showDetails: true });

    case ActionTypes.LOAD_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        selectedCustomTreatment: action.payload,
      });

    case ActionTypes.ADD:
      return Object.assign({}, state, { loading: true });

    case ActionTypes.ADD_SUCCESS:
      return Object.assign({}, state, {
        customTreatments: [...state.customTreatments, action.payload],
        showDetails: true,
        selectedCustomTreatment: action.payload,
        loading: false,
      });

    case ActionTypes.ADD_FAIL:
      return Object.assign({}, state, { loading: false });

    case ActionTypes.UPDATE:
      return Object.assign({}, state, { loading: true });

    case ActionTypes.UPDATE_SUCCESS:
      return Object.assign({}, state, {
        customTreatments: state.customTreatments.map((customTreatment) => {
          return customTreatment.id === action.payload.id
            ? Object.assign({}, customTreatment, action.payload)
            : customTreatment;
        }),
        loading: false,
      });

    case ActionTypes.UPDATE_FAIL:
      return Object.assign({}, state, { loading: false });

    case ActionTypes.DELETE:
      return Object.assign({}, state, { loading: true });

    case ActionTypes.DELETE_SUCCESS:
      return Object.assign({}, state, {
        customTreatments: state.customTreatments.filter(
          (customTreatment) => customTreatment.id !== action.payload.id,
        ),
        showDetails: false,
        loading: false,
      });

    case ActionTypes.DELETE_FAIL:
      return Object.assign({}, state, { loading: false });

    case ActionTypes.CREATE:
      return Object.assign({}, state, {
        selectedCustomTreatment: {},
        showDetails: true,
      });

    case ActionTypes.CLOSE:
      return Object.assign({}, state, {
        showDetails: false,
        selectedCustomTreatment: null,
      });

    default:
      return state;
  }
}

export const getCustomTreatments = (state: State) =>
  state.customTreatments
    .filter((customTreatment) => {
      return true;
    })
    .sort((a, b) => {
      return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
    });
export const getSelected = (state: State) => state.selectedCustomTreatment;
export const isLoading = (state: State) => state.loading;
export const getShowDetails = (state: State) => state.showDetails;



// WEBPACK FOOTER //
// /app/src/app/core/store/custom-treatment/custom-treatment.reducer.ts